"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Message;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("@JohnLewisPartnership/jl-design-system/dist/components/icon/ALPHA/Icon");
var _messageModule = _interopRequireDefault(require("./message.module.scss"));
var _icon = _interopRequireDefault(require("../icon/icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MessageIcon = function MessageIcon(_ref) {
  var icon = _ref.icon,
    messageType = _ref.messageType,
    className = _ref.className,
    style = _ref.style,
    size = _ref.size;
  if (icon) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon["default"], {
    name: icon,
    color: "heritage-green",
    className: className,
    style: style,
    size: size
  });
  switch (messageType) {
    case 'error':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ALPHA_Icon, {
        name: "error",
        size: "large",
        style: "filled",
        className: className
      });
    case 'warning':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ALPHA_Icon, {
        name: "warning",
        size: "large",
        style: "filled",
        className: className
      });
    case 'success':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ALPHA_Icon, {
        name: "tick-circle",
        size: "large",
        style: "filled",
        className: className
      });
    case 'information':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ALPHA_Icon, {
        name: "info",
        size: "large",
        style: "filled",
        className: className
      });
    default:
      return null;
  }
};
function Message(_ref2) {
  var title = _ref2.title,
    copy = _ref2.copy,
    icon = _ref2.icon,
    htmlContent = _ref2.htmlContent,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'information' : _ref2$type,
    style = _ref2.style,
    size = _ref2.size;
  var body = htmlContent ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    dangerouslySetInnerHTML: {
      __html: htmlContent
    }
  }) : copy !== null && copy !== void 0 ? copy : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames["default"])(_messageModule["default"].wrapper, _messageModule["default"][type]),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MessageIcon, {
      messageType: type,
      icon: icon,
      className: _messageModule["default"].icon,
      style: style,
      size: size
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _messageModule["default"].content,
      children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _messageModule["default"].title,
        children: title
      }), body && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _messageModule["default"].body,
        children: body
      })]
    })]
  });
}